<template>
  <div class="w-full h-screen antialiased bg-gray-50 dark:bg-gray-900">
    <AdministratorHeader />
    <main class="mx-auto max-w-screen-lg">
      <router-view />
    </main>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import Header from '@/views/administrator/partials/Header.vue';

export default defineComponent({
  name: 'AdminLayout',
  components: {AdministratorHeader: Header},
});
</script>
